function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Link as RouterLink } from '@tanstack/react-router';
import { cva } from 'class-variance-authority';
import { cn } from '../..';
const linkVariants = cva(// Base styles - matches MUI Link default
'text-purple-400 text-xs underline underline-offset-4 transition-all duration-75 ease-in-out py-1 border-none hover:text-foreground focus:text-purple-400 focus:outline-none', {
    variants: {
        variant: {
            default: '',
            white: 'text-foreground hover:text-muted-foreground focus:text-foreground'
        },
        focusBorder: {
            true: 'focus:rounded-lg',
            false: ''
        }
    },
    compoundVariants: [
        {
            variant: 'white',
            focusBorder: true,
            className: 'focus:border focus:border-muted-foreground'
        },
        {
            variant: 'default',
            focusBorder: true,
            className: 'focus:border focus:border-purple-400'
        }
    ],
    defaultVariants: {
        variant: 'default',
        focusBorder: false
    }
});
export function Link(_0) {
    let { children, variant, focusBorder, className } = _0, linkProps = _object_without_properties(_0, [
        "children",
        "variant",
        "focusBorder",
        "className"
    ]);
    // Backward compatibility: detect 'white' in className
    const hasWhiteClass = className === null || className === void 0 ? void 0 : className.includes('white');
    const hasFocusBorderClass = className === null || className === void 0 ? void 0 : className.includes('focus-border');
    // Clean className of our custom classes
    const cleanClassName = className === null || className === void 0 ? void 0 : className.replace(/\bwhite\b/g, '').replace(/\bfocus-border\b/g, '').trim();
    const effectiveVariant = hasWhiteClass ? 'white' : variant;
    const effectiveFocusBorder = hasFocusBorderClass ? true : focusBorder;
    return /*#__PURE__*/ _jsx(RouterLink, _object_spread_props(_object_spread({}, linkProps), {
        className: cn(linkVariants({
            variant: effectiveVariant,
            focusBorder: effectiveFocusBorder
        }), cleanClassName),
        children: children
    }));
}
export { linkVariants };
